<template>
	<div>
		<section id="skill" class="d-flex flex-column p-3 p-lg-5">
			<div class="container">
				<!--                <h3 class=" container block_title text-white">Coding Skills</h3>-->
				<div class="col-12 about-content-header text-center my-3">
					<span class="water-text">Skills</span>
					<h2 class="page-section-heading text-center mb-0">Skills</h2>
					<div class="divider-custom">
						<div class="divider-custom-line" />
						<div class="divider-custom-icon">
							<i class="fas fa-star" />
						</div>
						<div class="divider-custom-line" />
					</div>
				</div>

				<div class="languages skills show-on-scroll">
					<i class="devicon-html5-plain-wordmark colored technology"></i>
					<i class="devicon-css3-plain-wordmark colored technology"></i>
					<i class="devicon-sass-original technology"></i>
					<i class="devicon-bootstrap-plain-wordmark technology"></i>
					<i class="devicon-javascript-plain colored technology"></i>
					<i class="devicon-jquery-plain-wordmark colored"></i>

					<i class="devicon-php-plain technology"></i>
					<i class="devicon-laravel-plain-wordmark colored technology"></i>
					<i class="devicon-codeigniter-plain-wordmark colored"></i>
					<i class="devicon-cakephp-plain-wordmark colored"></i>
					<i class="devicon-wordpress-plain-wordmark colored"></i>
					<i class="devicon-mysql-plain-wordmark colored technology"></i>

					<i class="devicon-vuejs-plain-wordmark colored"></i>
					<i class="devicon-react-plain-wordmark colored technology"></i>
					<i class="devicon-git-plain-wordmark colored technology"></i>

					<i class="devicon-phpstorm-plain-wordmark colored"></i>
					<i class="devicon-docker-plain-wordmark technology"></i
					><i class="devicon-github-original technology"></i>
				</div>
				<!--        <div v-if="show_skill" class="row text-center my-auto">-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fab fa-html5 fa-5x skill_icon" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="95" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>HTML5</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fab fa-css3 fa-5x skill_icon" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="90" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>CSS3</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fab fa-bootstrap fa-5x skill_icon" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="87" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>Bootstrap</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fab fa-js fa-5x skill_icon" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="80" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>JavaScript & JQuery</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fa fa-globe fa-5x skill_icon" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="85" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>PHP</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6">-->
				<!--            <i class="devicon-laravel-plain-wordmark colored"></i>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6 skill_icon">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fab fa-vuejs fa-5x" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="75" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>Vue Js</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--          <div class="col-md-3 col-sm-6 skill_icon">-->
				<!--            <div class="skill-item">-->
				<!--              <i class="fas fa-database fa-5x" />-->
				<!--              <h2>-->
				<!--                <span>-->
				<!--                  <number :from="0" :to="80" :duration="5" />-->
				<!--                </span>-->
				<!--                <span>%</span>-->
				<!--              </h2>-->
				<!--              <p>MySQL</p>-->
				<!--            </div>-->
				<!--          </div>-->
				<!--        </div>-->
			</div>
		</section>
	</div>
</template>

<script>
export default {
	// data() {
	// 	return {
	// 		show_skill: false,
	// 	};
	// },
	mounted() {
		// Auto Calling A method when scroll the page
	},
	methods: {
		inSkill() {
			this.$emit("inSkill");
		},
		// viewHandler() {
		// 	var scroll = window.pageYOffset;
		// 	if (scroll > 100) {
		// 		this.show_skill = true;
		// 	}
		// },
	},
};
</script>

<style lang="scss" scoped></style>
